<app-pcbread-crumb [data]="breadCrumb"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable [data]="data" [entityField]="fields" (parentAction)="parentAction($event)">
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<ng-template #ModalContent let-modal class="modal-width">
  <app-drug-modal 
    [thisValue]="thisValue"
    [activeAddModal]="false"
    [EditUrl]="'Support'"
    (parentAction)="parentAction($event)"
    >
  </app-drug-modal>
</ng-template>

<ng-template #ModalChange let-modal class="modal modal-top fade">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" *ngIf="!activeAddModal; else addTitle">
        {{ "ReplacementExistingDrug" | translate }}
        <span class="ms-2">
          {{ thisValue.persianName }}
        </span>
      </h5>
      <ng-template #addTitle>
        <h5 class="modal-title">
          {{ "AddDrugTitle" | translate }}
        </h5>
      </ng-template>
      <button
        type="button"
        class="btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-6 mb-3">
          <div
            class="edit-form"
            appClickOutside
            (clickOutside)="modalIsOpen = false"
          >
            <label class="form-label" for="drugnewDrug">
              {{ "newDrug" | translate }}
            </label>

            <input
              id="drugnewDrug"
              type="text"
              autocomplete="off"
              class="form-control"
              placeholder="{{ 'newDrug' | translate }}"
              [(ngModel)]="thisValue.name"
              disabled
            />
          </div>
        </div>
        <div class="col-6 mb-3">
          <div
            class="edit-form"
            appClickOutside
            (clickOutside)="modalIsOpen = false"
          >
            <div class="validation-alert-sale-buy">
              <p>{{ changeDrugValidationMessage }}</p>
            </div>
            <label class="form-label" for="drugBrandName">
              {{ "SelectDrug" | translate }}
            </label>

            <form [formGroup]="drugSearchForm">
              <input
                id="drugBrandName"
                type="text"
                autocomplete="off"
                appSelectOnFocus
                formControlName="drugBrandName"
                class="form-control Focusable iner-Focusable search-input-box"
                placeholder="{{ 'SearchAndScanBarcode' | translate }}"
                [ngClass]="{
                  'is-invalid':
                    changeDrugValidationMessage != '' &&
                    changeDrugValidationMessage != null
                }"
                [(ngModel)]="this.newDrugName"
                (keyup.escape)="modalIsOpen = false"
              />
            </form>
            <app-search-box
              [data]="searchData"
              [urlName]="'DrugSearchBoxTable'"
              [paging]="searchPaging"
              *ngIf="modalIsOpen"
              (parentAction)="parentSearchAction($event)"
            ></app-search-box>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="col-12 d-flex justify-content-between">
        <button class="btn btn-primary btn-next" (click)="saveChangeDrug()">
          <span class="d-sm-inline-block d-none me-sm-1">
            {{ "Submit" | translate }}</span
          >
        </button>
      </div>
    </div>
    <app-loading-panel *ngIf="loading"></app-loading-panel>
  </div>
</ng-template>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>
